import React from 'react';
import { SpecificStateContainer, EllipseContainer, TitleText, SubTitleText } from './styled';
export const SpecificState = ({ height, icon, title, subTitle }) => (React.createElement(SpecificStateContainer, { height: height },
    React.createElement(EllipseContainer, null, icon),
    React.createElement(TitleText, { variant: "headingLarge" }, title),
    subTitle && React.createElement(SubTitleText, { variant: "subheadingMedium" }, subTitle)));
//# sourceMappingURL=SpecificState.js.map